const MULTI_SELECT = 'MULTI_SELECT'
const MULTIPLE_CHOICE = 'MULTIPLE_CHOICE'
const NUMBER = 'NUMBER'
const FREE_TEXT = 'FREE_TEXT'
const DATE = 'DATE'
const FULL_NAME = 'FULL_NAME'
const PHONE_NUMBER = 'PHONE_NUMBER'
const EMAIL = 'EMAIL'
const MULTIPLE_CHOICE_ADDITIONAL = 'MULTIPLE_CHOICE_ADDITIONAL'
const YES_NO_ADDITIONAL = 'YES_NO_ADDITIONAL'
const USER_ZIP_CODE = 'USER_ZIP_CODE'

export default {
  MULTI_SELECT,
  MULTIPLE_CHOICE,
  NUMBER,
  FREE_TEXT,
  DATE,
  FULL_NAME,
  PHONE_NUMBER,
  EMAIL,
  MULTIPLE_CHOICE_ADDITIONAL,
  YES_NO_ADDITIONAL,
  USER_ZIP_CODE,
}
